import amplitude from 'amplitude-js';

const environment = window.location.hostname.includes('staging') ? 'stg'
    : window.location.hostname === 'localhost' ? 'dev'
        : 'prod';


export const initAmplitude = () => amplitude.getInstance().init("c741a3c0bc70a55f687ec4b5044a3d94");

export const logEvent = (eventName, eventProperties = {}) => {
    amplitude.getInstance().logEvent(eventName, {...eventProperties, environment: environment});
}
